const defaultState = {
    users: [],
    user: {},
    loading: false,
    errors:{}
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {
      case 'FETCH_USERS_FULFILLED': {
        return {
          ...state,
          users: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_USERS_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_USERS_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'NEW_USER': {
        return {
          ...state,
          user: {}
        }
      }
  
      case 'SAVE_USER_PENDING': {
        return {
          ...state,
          loading: true
        }
      }
  
      case 'SAVE_USER_FULFILLED': {
        return {
          ...state,
          users: [...state.users, action.payload.data],
          errors: {},
          loading: false
        }
      }

      case 'SAVE_USER_REJECTED': {
        const data = action.payload.response.data;
        // convert feathers error formatting to match client-side error formatting
        const { USER_EDP_AD, USERNAME, COMPANY, PROFILE, TIMEZONE, COUNTRY_CODE } = data.errors;
        const errors = { global: data.message, USER_EDP_AD, USERNAME, COMPANY, PROFILE, TIMEZONE, COUNTRY_CODE };
        return {
          ...state,
          errors: errors,
          loading: false
        }
      }
  
      case 'FETCH_USER_PENDING': {
        return {
          ...state,
          loading: true,
          user: {}
        }
      }
  
      case 'FETCH_USER_FULFILLED': {
        return {
          ...state,
          user: action.payload.data[0],
          errors: {},
          loading: false
        }
      }
  
      case 'UPDATE_USER_PENDING': {
        return {
          ...state,
          loading: true
        }
      }
  
      case 'UPDATE_USER_FULFILLED': {
        const user = action.payload.data;
        return {
          ...state,
          users: state.users.map(item => item.ID === user.ID ? user : item),
          errors: {},
          loading: false
        }
      }
  
      case 'UPDATE_USER_REJECTED': {
        const data = action.payload.response.data;
        const { USER_EDP_AD, USERNAME, COMPANY, PROFILE, TIMEZONE, COUNTRY_CODE } = data.errors;
        const errors = { global: data.message, USER_EDP_AD, USERNAME, COMPANY, PROFILE, TIMEZONE, COUNTRY_CODE };
        return {
          ...state,
          errors: errors,
          loading: false
        }
      }
  
      case 'DELETE_USER_FULFILLED': {
        const id = parseInt(action.payload.data.ID,10);
        return {
          ...state,
          users: state.users.filter(item => item.ID !== id)
        }
      }
  
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/user-reducer.js